<template>
    <component :is="tag">
        <slot
            :proposalStep="step"
            :campaign="campaign"
            :proposal="proposal"
            :contact="contact"
            :campaign-fields="campaignFields"
            :countries="countries"
            :go-next-step="goNextStep"
            :go-previous-step="goPreviousStep"
            :patch-proposal-step="patchProposalStep"
            :isLoading="isLoading"
            :is-completing-proposal="isCompletingProposal"
            :is-patching-proposal="isPatchingProposal"
            :errors="errors"
            :errorMessage="errorMessage"
        />
    </component>
</template>
<script>
    import BaseProposalStepMixin    from "../mixins/BaseProposalStepMixin";
    import {NAME_PERSONAL_INFO} from "../../../constants/proposal-steps";

    export default {
        name: "PersonalInfoProvider",
        mixins: [
            BaseProposalStepMixin,
        ],
        computed: {
            step(){
                return this.proposalSteps[NAME_PERSONAL_INFO]
            },
        },
        created() {
            this.isLoading = true;

            this.loadContact()
                .then(() => {
                    return Promise.all([
                        this.loadCampaign(),
                        this.loadProposal(),
                        this.loadCampaignFields(),
                        this.loadCountries(),
                    ]);
                })
                .then(() => {
                    this.initProposalStep(this.step);
                })
                .catch(error => this.handleHttpError(error))
                .then(() => {
                    this.isLoading = false;
                });
        }
    }
</script>

<style scoped>

</style>
